import WizardTabulatedData from './WizardTabulatedData';

export default WizardTabulatedData;
